import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { filter, map, first } from 'rxjs/operators';
import { AuthService } from './auth.service';

import { BaseService } from './base.service';
import { ConvertIdService } from './convert-id.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private base: BaseService,
    private convertIdService: ConvertIdService,
    private authService: AuthService
  ) {}

  get isAdmin$() {
    return this.authService.user$.pipe(
      filter((_) => !!_),
      map((_) => _.is_admin)
    );
  }

  getUserTypeById(id: string) {
    return this.base
      .get(`type/user/${this.convertIdService.convertIdStringToNumber(id)}`)
      .pipe(
        filter((res) => !!res && res.user),
        first(),
        map((response: any) => response.user.type)
      );
  }
}
